import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import BrandingHeader from '@/components/BrandingHeader';
import IntroSwiper from '@/components/IntroSwiper';
import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';
import { getBrandingLogoUrl } from '@/utils/logo';

import CustomContent from './CustomContent';
import styles from './index.module.scss';
import { Footer } from '@/components/Footer/Footer';

const AppLayout = () => {
  const { isMobile } = usePlatform();
  const { experienceSettings, theme } = useContext(PageContext);

  const isDarkModeEnabled = experienceSettings?.color.isDarkModeEnabled ?? false;
  const branding = experienceSettings?.branding;
  const logo = branding ? getBrandingLogoUrl({ theme, branding, isDarkModeEnabled }) : null;

  return (
    <>
      {experienceSettings && (
        <BrandingHeader
          className={classNames(styles.header, layoutClassNames.brandingHeader)}
          logo={logo}
        />
      )}
      <div className={styles.viewBox}>
        <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
          <IntroSwiper />
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <div className={styles.rightContainer}>
            <main className={classNames(styles.main, layoutClassNames.mainContent)}>
              <Outlet />
            </main>
          </div>
        </div>
        <div className={styles.decorationContainer}>
          <div className={styles.gradientBlob1} />
          <div className={styles.gradientBlob2} />
          <div className={styles.gradientBlob3} />
        </div>
        <Footer className="outer-footer" />
      </div>
    </>
  );
};

export default AppLayout;
